import { render, staticRenderFns } from "./simple-rect.vue?vue&type=template&id=1e78c2f2&"
import script from "./simple-rect.vue?vue&type=script&lang=js&"
export * from "./simple-rect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports